export const ACTIVITY = {
  DA_VIRTUAL_CLASS: "DA_VIRTUAL_CLASS",
  DA_PHYSICAL_CLASS: "DA_PHYSICAL_CLASS",
  DA_URL_RES: "DA_URL_RES",
  DA_SCORM: "DA_SCORM",
  DA_XAPI: "DA_XAPI",
  SYNC: "SYNC",
  ASYNC: "ASYNC",
  BLENDED: "BLENDED",
  CUSTOM: "CUSTOM",
  NULL: "null",
  DA_EXTERNAL_RES: "DA_EXTERNAL_RES",
  DA_YOUTUBE: "DA_YOUTUBE",
  DA_LINKEDIN: "DA_LINKEDIN",
  DA_LTI: "DA_LTI",
  DA_SURVEY: "DA_SURVEY",
  COURSE: "COURSE",
  PATH: "PATH",
};
